import * as actions from './slice'

const userEmailMigrationUpdate = {
  eventName: 'userEmailMigrationUpdate',
  onStart: [{
    action: actions.reset,
    redux: true
  }, {
    action: () => actions.setLoading(true),
    redux: true
  }],
  onSuccess: [{
    action: actions.setResults,
    redux: true
  }]
}

export {
  userEmailMigrationUpdate
}
